<template>
  <div class="info">
    <div class="header">
      <div class="container" @click="toLogin">
        <img class="logo" src="../assets/images/login_icon1.png" alt="">
        <div class="con">
          <p class="big">国培计划(2021)</p>
          <p class="small">中小学教师网络法治教育培训项目</p>
        </div>
        <!-- <div class="btn" @click="toLogin">登录</div> -->
      </div>
    </div>
    <div class="masking">
      <div class="mask_box"  @click="toLogin">
        <div class="title">初次登录信息补充</div>
        <div class="mask_con">
          <img src="../assets/images/login_icon6.png" alt="">
        </div>
        <div class="tips">
          <p>您的资料已提交，请重新登录开始学习。</p>
        </div>
        <!-- <div class="btn" @click="toIndex"><<回首页 </div> -->
      </div>
    </div>
   <!-- <div class="footer">
      <div class="container">
        <p class="top">北京国语大学  外语教学与研究出版社 教育部全国青少年普法网运营中心</p>
        <p class="cen">网站概况        机构职能        版权与免责声明</p>
        <p class="bot">© 2020  外语教学与研究出版社  版权所有  |  京ICP备10028400号-3 </p>
      </div>
    </div> -->
  </div>
</template>

<script>
  export default {
    data () {
      return {

      }
    },
    methods:{
      toLogin(){
        window.open("http://qspfw.moe.gov.cn/html/gpjh/");
      },
    }
  }
</script>

<style scoped>
.info{
  background-color: #e9e9e9;
}

.masking{
  width: 100%;
  height: 100%;
  padding: 1.5rem 0;
  /* background-color: rgba(0,0,0,0.7); */
  /* position: fixed; */
  /* top: 0; */
  /* left: 0; */
  /* bottom: 0; */
  /* right: 0; */
  /* z-index: 20; */
}
.masking .mask_box{
  width: 10.86rem;
  height: 4rem;
  margin: 0 auto;
  /* position: absolute; */
  /* top: 50%; */
  /* left: 50%; */
  /* transform: translate(-50%,-50%); */
  background-color: #fff;
  z-index: 22;
  border-radius: 0.1rem;
}
.masking .mask_box .title{
  font-size: 0.18rem;
  color: #000;
  font-weight: 700;
  padding-top: 0.31rem;
  width: 10rem;
  margin-left: 0.55rem;
}

.masking .mask_box .mask_con{
  width: 0.94rem;
  height: 0.93rem;
  margin: 0.7rem auto 0.6rem auto;
}
.masking .mask_box .mask_con img{
  width: 100%;
  height: 100%;
}
.masking .mask_box .tips{
  width: 100%;
}
.masking .mask_box .tips p{
  font-size: 0.14rem;
  color: #666;
  line-height: 0.22rem;
  text-align: center;
}
.masking .mask_box .btn{
  width: 1.37rem;
  height: 0.36rem;
  margin: 0.4rem auto;
  background-color: #de0000;
  font-size: 0.16rem;
  color: #fff;
  border-radius: 0.05rem;
  text-align: center;
  line-height: 0.36rem;
  cursor: pointer;
  user-select: none;
}


.header{
  width: 100%;
  height: 1rem;
  background-color: #fff;
}
.header .container{
  width: 12rem;
  height: 1rem;
  margin: 0 auto;
}
.header .container .logo{
  width: 0.58rem;
  height: 0.58rem;
  float: left;
  margin: 0.26rem 0.14rem 0 0;
}
.header .container .con{
  width: 9rem;
  height: 1rem;
  float: left;
}
.header .container .big{
  font-size: 0.2rem;
  color: #de0000;
  font-weight: 700;
  margin-top: 0.36rem;
  line-height: 0.2rem;
}
.header .container .small{
  font-size: 0.16rem;
  color: #000;
  line-height: 0.16rem;
  margin-top: 0.05rem;
}
.header .container .btn{
  float: right;
  width: 0.8rem;
  height: 0.38rem;
  line-height: 0.38rem;
  background-color: #de0000;
  border-radius: 0.1rem;
  font-size: 0.16rem;
  color: #fff;
  text-align: center;
  margin-top: 0.36rem;
  cursor: pointer;
  user-select: none;
}


.content{
  width: 12rem;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 0.2rem;
  overflow: hidden;
  margin-top: 0.42rem;
  padding-bottom: 0.3rem;
}
.content .top{
  height: 0.64rem;
  width: 100%;
  background-color: #DE0000;
  display: flex;
  justify-content: center;
  align-items: center;

}
.content .top img{
  width: 0.3rem;
  height: 0.3rem;
  margin-right: 0.27rem;
}
.content .top span{
  font-size: 0.24rem;
  color: #fff;
}

.content .form{
  width: 100%;
  margin-top: 0.8rem;
}


.content .form .up_head{
  width: 2.5rem;
  margin-left: 1rem;
}
.content .form .up_head .label{
  float: left;
  font-size: 0.16rem;
  color: #333;
}
.content .form .up_head .label .symbol{
  font-size: 0.16rem;
  color: #e60012;
}
.content .form .up_head .head{
  width: 1.1rem;
  height: 1.1rem;
  border-radius: 50%;
}
.content .form .up_head .up_btn{
  margin-left: 0.4rem;
}
.content .form .up_head p{
  font-size: 0.14rem;
  color: #b5b5b5;
  margin-left: 0.4rem;
}




.content .form .gender{
  float: left;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 0.06rem;
  cursor: pointer;
  user-select: none;
}
.content .form .gender img{
  margin-right: 0.06rem;
}
.content .form .el-input__inner{
  background-color: #f1f1f1;
  border-color: #f1f1f1;
}
.content .form .el-form-item__label{
  font-size: 0.16rem;
  color: #333;
}

.content .form .distance{
  width: 100%;
  height: 0.5rem;
}
.content .form .distance span{
  font-size: 0.25rem;
  line-height: 0.47rem;
  color: #7c7c7c;
  float: left;
  margin-right: 0.2rem;
}
.content .form .distance >>> .distpicker-address-wrapper{
  float: left;
}
.content .form .distance >>> .distpicker-address-wrapper select{
  text-align: right;
  font-size: 0.16rem;
  color: #333;
  outline: none;
  float: left;
  padding: 0;
  width: 2.07rem;
  height: 0.45rem;
  line-height: 0.45rem;
  border-radius: 4px;
  margin-right: 0.11rem;
  background-color: #f1f1f1;
}

.content .form >>> .el-textarea__inner{
  background-color: #f1f1f1;
  border: none;
  outline: none;
  border-radius: 4px;
}
.content .form >>> .el-input__inner{
  background-color: #f1f1f1;
  border: none;
  outline: none;
  border-radius: 4px;
}
.content .form .up_btn{
  width: 1.27rem;
  height: 0.38rem;
  background-image: linear-gradient(0deg,
    #f2f2f2 0%,
    #ffffff 100%),
  linear-gradient(
    #f1f1f1,
    #f1f1f1);
  background-blend-mode: normal,
    normal;
  border-radius: 0.02rem;
  border: solid 0.01rem #e4e4e4;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  margin-bottom: 0.1rem;
}
.content .form .up_btn span{
  font-size: 0.16rem;
  color: #333;
}
.content .form .up_btn img{
  margin-right: 0.09rem;
}
.content .form .submit{
  width: 1.03rem;
  height: 0.42rem;
  background-color: #de0000;
  border-radius: 0.08rem;
  margin-top: 0.1rem;
}

.footer{
  width: 100%;
  height: 1.68rem;
  background-color: #2b2b2b;
  margin-top: 0.42rem;
}
.footer .container{
  width: 12rem;
  height: 100%;
  margin: 0 auto;
}
.footer .container .top{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #de0000;
  padding-top: 0.45rem;
}
.footer .container .cen{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
  margin-top: 0.21rem;
}
.footer .container .bot{
  font-size: 0.14rem;
  line-height: 0.14rem;
  color: #fff;
   margin-top: 0.21rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Audit.vue